export default __webpack_public_path__ + "static/media/search_large.6168751f.svg";